var m = require('mithril');
var reports = require('../reports/reports');
var edit = require('../layout/components/edit');
var header = require('../layout/components/header');
var tabs = require('../components/tabs');
var reports = require('../reports/reportFolders');
var aggregates = require('./aggregates');
var alarmProfiles = require('../alarms/alarmProfiles');

var component = {};

component.oninit = function () {
  var ctrl = this;
  document.title = 'nimrod | vistest_01';
  header.vm.activeTab('Data');

  ctrl.squares = [];
  ctrl.squareIndex = 0;

  ctrl.advanceSquares = function () {
    console.log('advance')
    ctrl.squares.push({id: ctrl.squareIndex})
    ctrl.squareIndex += 1;
    m.redraw();
  }

  setInterval(ctrl.advanceSquares, 1000);
};

component.view = function () {
  var ctrl = this;
  return m('div.flex', {style: {height: '20em'}}, [
    ctrl.squares.map(squareSpec => {
      return m('div.w5.ba2.bg-black.mh3', m('h1', squareSpec.id));
    }),

    m('div', {style: {}}, [
      ctrl.squares.map(squareSpec => {
        return m('div.w5.ba2.bg-black.mh3', m('h1', squareSpec.id));
      })
    ])
  ])
};

module.exports = component;
